import React, { Fragment, useEffect, useContext } from 'react';
import { Route, useLocation } from 'wouter';
import UnauthLayout from './UnauthLayout';
import { AuthContext } from "../contexts/auth";

const UnauthenticatedRoute = ({ component: Component, ...rest }) => {
  const { token } = useContext(AuthContext);
  const [location, setLocation] = useLocation();

  useEffect(() => {
    if (token ) {
      // Redirect only if not already at '/'
      setLocation('/');
    }
  }, [token, location, setLocation]);


  return (
    <Route {...rest}>
      {
        !token ? (
          <UnauthLayout>
            <Component {...rest} />
          </UnauthLayout>
        ) : null  // Render nothing or a placeholder if authenticated
      }
    </Route>
  );
};

export default UnauthenticatedRoute;
